<template>
  <div class="container">
    <!-- Header -->
    <!-- <v-row class="page-header">
      <v-col class="page-title" cols="12">
        <v-toolbar-title class="font-bold">Dashboard</v-toolbar-title>
      </v-col>
    </v-row> -->
    <v-row>
      <v-col cols="12" lg="1"> </v-col>
      <v-col cols="12" lg="10">
        <!-- 2022.2.14 203728 Remove v-if="$cookies.get('comp-adminrepo-use-yn') === 'Y'" -->
        <v-row class="dashboard-header">
          <v-col cols="12" md="12" class="d-flex justify-center dashboard-period">
            <div class="v-btn-group">
              <v-btn
                class="v-btn__period"
                v-for="(item, index) in termTxt"
                :key="termTxt[index]"
                :class="{ 'v-btn__active': isActive === index }"
                @click="changeTab(index)"
              >
                {{ item }}
              </v-btn>
            </div>
            <!-- <v-slider
              v-model="term"
              :tick-labels="termTxt"
              color="#00B8D9"
              min="0"
              max="3"
              step="1"
              ticks="always"
              tick-size="4"
              hide-details
              :track-color="`${$vuetify.theme.dark ? '#FFFFFF' : '#EAF1F8'}`"
              @change="refresh()"
            ></v-slider> -->
          </v-col>
        </v-row>
        <!-- // 203737 05/10/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu -->
        <system-progress
          :sysloading="isLoading"
          :sysloadingTitle="sysloadingTitle"
        ></system-progress>
        <v-row>
          <!-- class="grid-content" -->
          <v-col cols="12">
            <v-row class="pb-3">
              <v-col cols="12" lg="5" class="pl-5 pr-6">
                <div class="bg-chart">
                  <div class="pb-5">
                    {{ $t('lbl.dashboard.transts') }}
                  </div>
                  <v-row class="p-0">
                    <v-col cols="12" md="5" class="p-0 pl-10 pr-10">
                      <div class="Chart">
                        <chartDoughnet
                          ref="status_chart"
                          :chartData="statusChartData"
                          :options="statusOptions"
                          :height="250"
                        >
                        </chartDoughnet>
                      </div>
                    </v-col>
                    <v-col cols="12" md="7" class="pr-10">
                      <v-row>
                        <v-col
                          class="text-right pr-5"
                          style="height: 140px; font-weight: 600; font-size: 44px"
                        >
                          {{ totalCnt }}
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="1" xl="4" class="p-1"> </v-col>
                        <v-col cols="7" xl="5" class="p-1 chart-text">
                          <v-avatar :color="successColor" size="15" class="mr-2"></v-avatar
                          >{{ $t('lbl.dashboard.success') }}
                        </v-col>
                        <v-col cols="4" xl="3" class="p-1 pr-5 text-right chart-number">
                          {{ successCnt }}
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="1" xl="4" class="p-1"> </v-col>
                        <v-col cols="7" xl="5" class="p-1 chart-text">
                          <v-avatar :color="processingColor" size="15" class="mr-2"></v-avatar
                          >{{ $t('lbl.dashboard.process') }}
                        </v-col>
                        <v-col cols="4" xl="3" class="p-1 pr-5 text-right chart-number">
                          {{ processingCnt }}
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="1" xl="4" class="p-1"> </v-col>
                        <v-col cols="7" xl="5" class="p-1 chart-text">
                          <v-avatar :color="errorColor" size="15" class="mr-2"></v-avatar
                          >{{ $t('lbl.dashboard.err') }}
                        </v-col>
                        <v-col cols="4" xl="3" class="p-1 pr-5 text-right chart-number">
                          {{ errorCnt }}
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
              <v-col cols="12" lg="7" class="pl-6 pr-5">
                <div class="bg-chart">
                  <div class="pb-5">
                    {{ $t('lbl.dashboard.trans') }}
                  </div>
                  <div style="overflow-y: auto">
                    <v-simple-table dense fixed-header height="260" class="abnormal-transactions">
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th :style="getThStyle()">Sender</th>
                            <th :style="getThStyle()">Receiver</th>
                            <th :style="getThStyle()">Message</th>
                            <th :style="getThStyle()">Transaction Date</th>
                            <th :style="getThStyle()">Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in transactionList" :key="index">
                            <td :style="getTdStyle()">{{ item.senderId }}</td>
                            <td :style="getTdStyle()">{{ item.recipientId }}</td>
                            <td :style="getTdStyle()">{{ item.message }}</td>
                            <td :style="getTdStyle()">
                              {{ getDate(item.transactionDate) }}
                            </td>
                            <td
                              :style="getTdStyle()"
                              class="font-extrabold capitalize"
                              v-if="
                                item.processId !== null &&
                                  item.processId !== 'Unknown' &&
                                  item.processId !== undefined &&
                                  item.processId !== ''
                              "
                            >
                              <a
                                :style="`${getStatusColor(item.status)}`"
                                @click="openMonitoringStateViewWindow(item)"
                              >
                                {{ item.status }}
                              </a>
                            </td>
                            <td
                              :style="`${getTdStyle()} ${getStatusColor(item.status)}`"
                              class="font-extrabold capitalize"
                              v-else
                            >
                              {{ item.status }}
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" lg="6" class="pl-5 pr-6">
                <div class="bg-chart">
                  <div class="pb-5">
                    <span style="color: #8895AA"> {{ $t('lbl.dashboard.transtCount') }}</span>
                    <span
                      >{{
                        $t('lbl.dashboard.partners', [
                          $cookies.get('comp-id') === $cookies.get('ownr-id') &&
                          $cookies.get('user-admin-yn') === 'Y'
                            ? 'Company'
                            : 'Partner',
                        ])
                      }}
                    </span>
                  </div>
                  <div class="Chart">
                    <chartBar
                      ref="partner_chart"
                      :chartData="partnerChartData"
                      :options="partnerOptions"
                      :height="250"
                    >
                    </chartBar>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" lg="6" class="pl-6 pr-5">
                <div class="bg-chart">
                  <div class="pb-5">
                    <span style="color: #8895AA"> {{ $t('lbl.dashboard.transtCount') }}</span>
                    <span> {{ $t('lbl.dashboard.message') }}</span>
                  </div>
                  <div class="Chart">
                    <chartBar
                      ref="message_chart"
                      :chartData="messageChartData"
                      :options="messageOptions"
                      :height="250"
                    >
                    </chartBar>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col style="height: 50px"> </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" lg="1"> </v-col>
    </v-row>
  </div>
</template>

<script>
import chartDoughnet from '@/vue-caas/views/dashboard/ChartDoughnet.vue';
import chartBar from '@/vue-caas/views/dashboard/ChartBar.vue';
import { mapState } from 'vuex';
import SystemProgress from '@/vue-dlb/components/SystemProgress.vue';
import { openWindow } from '@/vue-dlb/utils/window-opener';

export default {
  components: {
    chartDoughnet,
    chartBar,
    SystemProgress,
  },
  data: () => ({
    totalCnt: 0,
    successCnt: 0,
    processingCnt: 0,
    errorCnt: 0,
    // term: 0,
    termTxt: ['Today', '1 Week', '2 Week', '1 Month'],
    transactionList: [],
    statusOptions: {
      responsive: true,
      maintainAspectRatio: false,
      animation: {
        animateRotate: true,
        animateScale: true,
      },
      cutoutPercentage: 60,
      successColor: '',
      processingColor: '',
      errorColor: '',
      lineColor: '',
      themeDark: true,
      legend: {
        display: false,
        // align: 'end',
        // position: 'right',
        // labels: {
        //   fontFamily: 'Open Sans',
        //   padding: 14,
        //   fontSize: 14,
        //   boxWidth: 60,
        //   generateLabels: function(chart) {
        //     let data = chart.data;
        //     if (data.labels.length && data.datasets.length) {
        //       return data.labels.map(function(label, i) {
        //         let meta = chart.getDatasetMeta(0);
        //         let ds = data.datasets[0];
        //         let arc = meta.data[i];
        //         let custom = arc && arc.custom || {};
        //         let getValueAtIndexOrDefault = Chart.helpers.getValueAtIndexOrDefault;
        //         let arcOpts = chart.options.elements.arc;
        //         let fill = custom.backgroundColor ? custom.backgroundColor : getValueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
        //         let stroke = custom.borderColor ? custom.borderColor : getValueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
        //         let bw = custom.borderWidth ? custom.borderWidth : getValueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);
        //         // We get the value of the current label
        //         let value = chart.config.data.datasets[arc._datasetIndex].data[arc._index];

        //         return {
        //           // Instead of `text: label,`
        //           // We add the value to the string
        //           text: label + '   (' + value + ')',
        //           fillStyle: fill,
        //           strokeStyle: stroke,
        //           lineWidth: bw,
        //           hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
        //           index: i
        //         };
        //       });
        //     } else {
        //       return [];
        //     }
        //   }
        // },
      },
    },
    statusChartData: {
      labels: ['Success', 'Processing', 'Error'],
      datasets: [],
    },
    partnerOptions: {
      responsive: true,
      maintainAspectRatio: false,
      animation: {
        animateRotate: true,
        animateScale: true,
      },
      legend: {
        display: false,
      },
      scales: {
        xAxes: [
          {
            gridLines: {
              display: false,
            },
            ticks: {
              fontColor: '',
              display: false,
            },
          },
        ],
        yAxes: [
          {
            gridLines: {
              offsetGridLines: false,
              drawBorder: false,
            },
            ticks: {
              fontColor: '',
              display: false,
            },
          },
        ],
      },
    },
    partnerChartData: {
      // labels: ['Pantos', 'CJ', 'SGL', 'Binex', 'BNX', 'Joosung', 'Abcd', 'Efgh', 'Ijkl', 'Mnop'],
      labels: [],
      datasets: [],
    },
    messageOptions: {
      responsive: true,
      maintainAspectRatio: false,
      animation: {
        animateRotate: true,
        animateScale: true,
      },
      legend: {
        display: false,
      },
      scales: {
        xAxes: [
          {
            gridLines: {
              display: false,
            },
            ticks: {
              fontColor: '',
              display: false,
            },
          },
        ],
        yAxes: [
          {
            gridLines: {
              offsetGridLines: false,
              drawBorder: false,
            },
            ticks: {
              fontColor: '#535761',
              display: false,
            },
          },
        ],
      },
    },
    messageChartData: {
      labels: [],
      datasets: [],
    },
    procList: [],
    prnrList: {},
    compList: [],
    uploadingStatusNm: '',
    uploadingStatusStartDt: '',
    uploadingStatusEndDt: '',
    matchingStatusNm: '',
    matchingStatusStartDt: '',
    matchingStatusEndDt: '',
    isLoading: true,
    isActive: 0,
  }),
  watch: {
    '$vuetify.theme.dark'(newValue) {
      this.themeDark = newValue;
      this.getChartColor();
      this.refresh();
    },
  },
  computed: {
    ...mapState('dashboard', {
      uploadingStatus: 'uploadingStatus',
      matchingStatus: 'matchingStatus',
    }),
    ...mapState('common', {
      sysloadingTitle: 'sysloadingTitle',
    }),
  },
  created() {
    try {
      const searchItems = {
        header: ['CUST_ID'],
        data: [{ CUST_ID: this.$cookies.get('comp-id') }],
      };
      this.$store.dispatch('dashboard/queryUploadingStatus', searchItems).then(() => {
        if (this.uploadingStatus && this.uploadingStatus.length > 0) {
          this.uploadingStatusNm = this.uploadingStatus[0].STS_CD_NM;
          this.uploadingStatusStartDt = this.uploadingStatus[0].START_DT || '';
          this.uploadingStatusEndDt = this.uploadingStatus[0].END_DT || '';
        }
      });
      this.$store.dispatch('dashboard/queryMatchingStatus', searchItems).then(() => {
        if (this.matchingStatus && this.matchingStatus.length > 0) {
          this.matchingStatusNm = this.matchingStatus[0].LAY_PRCS_STS_NM;
          this.matchingStatusStartDt = this.matchingStatus[0].START_DT || '';
          this.matchingStatusEndDt = this.matchingStatus[0].END_DT || '';
        }
      });
    } catch (err) {
      console.log(err);
    }

    this.$store.dispatch('getCompanyList').then(() => {
      this.$store.getters.companies.forEach((e) => {
        this.compList[e.compId] = e.compNm;
      });
    });

    const params = {
      srcProcNm: '',
      srcPrnrId: '',
      srcCompId: '',
      srcSendId: '',
      srcRecvId: '',
      srcMsgId: '',
      srcProcDirCd: '',
    };
    // 05/17/2021 SPKA-111 issue 53 Fix spiner when call api error
    this.$store
      .dispatch('getProcessList', params)
      .then(() => {
        this.procList = this.$store.getters.processList;
        // 2021.5.12 203728 Change Api Dashboard
        this.$store
          .dispatch('getDashBoardPartnerList')
          .then(() => {
            const tmpList = this.$store.getters.partnerList;
            for (let i = 0; i < tmpList.length; i += 1) {
              this.prnrList[tmpList[i].prnrId] = tmpList[i].prnrNm;
            }
            // alert(JSON.stringify(this.procList));
            this.refresh();
            this.isLoading = false;
          })
          .catch((ex) => {
            this.isLoading = false;
          });
      })
      .catch((ex) => {
        this.isLoading = false;
      });
    this.themeDark = this.$vuetify.theme.dark;
    this.getChartColor();
  },
  mounted() {},
  methods: {
    changeTab(index) {
      this.isLoading = true;
      this.refresh(index);
    },
    refresh(term) {
      const params = {};
      const startDate = new Date();
      const endDate = new Date();
      this.isActive = 0;
      if (term === 1) {
        this.isActive = 1;
        startDate.setDate(startDate.getDate() - 7);
      } else if (term === 2) {
        this.isActive = 2;
        startDate.setDate(startDate.getDate() - 14);
      } else if (term === 3) {
        this.isActive = 3;
        if (endDate.getDate() === 31) {
          startDate.setDate(1);
        } else {
          startDate.setMonth(startDate.getMonth() - 1);
          startDate.setDate(startDate.getDate() + 1);
        }
      }
      startDate.setHours(0);
      startDate.setMinutes(0);
      startDate.setSeconds(0);
      startDate.setMilliseconds(0);

      endDate.setHours(23);
      endDate.setMinutes(59);
      endDate.setSeconds(59);
      endDate.setMilliseconds(999);

      const startTimestamp = startDate.getTime();
      const endTimestamp = endDate.getTime();

      params.compId = this.$cookies.get('comp-id');
      // 2021.4.8 203728 issue 39
      params.ownrId = this.$cookies.get('ownr-id');
      params.startTimestamp = Math.floor(startTimestamp / 1000) + '';
      params.endTimestamp = Math.floor(endTimestamp / 1000) + '';

      this.$store.dispatch('getDashBoardDetail', params).then(() => {
        const dashboardDetail = this.$store.getters.dashboardDetail;
        this.updateStatusChart(dashboardDetail.transactions.payload);
        this.updateTransactionList(dashboardDetail.abnormalTransactions.payload);
        this.updatePartnerChart(dashboardDetail.partners.payload);
        this.updateMessageChart(dashboardDetail.messages.payload);
        this.isLoading = false;
      })
    },
    updateStatusChart(transactionStatus) {
      const statusDataset = {
        backgroundColor: [this.successColor, this.processingColor, this.errorColor],
        data: [
          Number(transactionStatus.success),
          Number(transactionStatus.processing),
          Number(transactionStatus.error),
        ],
        borderAlign: 'inner',
        borderWidth: 0,
      };
      this.successCnt = statusDataset.data[0]
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, '$&,')
        .split('.')[0];
      this.processingCnt = statusDataset.data[1]
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, '$&,')
        .split('.')[0];
      this.errorCnt = statusDataset.data[2]
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, '$&,')
        .split('.')[0];
      this.totalCnt = (statusDataset.data[0] + statusDataset.data[1] + statusDataset.data[2])
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, '$&,')
        .split('.')[0];
      this.statusChartData.datasets.splice(0, 1);
      this.statusChartData.datasets.push(statusDataset);
      this.$refs.status_chart.update();
    },
    updateTransactionList(abnormalTransaction) {
      this.partnerOptions.scales.yAxes[0].gridLines.color = this.lineColor;
      this.partnerOptions.scales.yAxes[0].gridLines.zeroLineColor = this.lineColor;
      this.partnerOptions.scales.yAxes[0].ticks.display = true;
      this.partnerOptions.scales.yAxes[0].ticks.fontColor = this.lineColor;
      this.partnerOptions.scales.xAxes[0].gridLines.color = this.lineColor;
      this.partnerOptions.scales.xAxes[0].gridLines.zeroLineColor = this.lineColor;
      this.partnerOptions.scales.xAxes[0].ticks.display = true;
      this.partnerOptions.scales.xAxes[0].ticks.fontColor = this.lineColor;
      for (let i = 0; i < abnormalTransaction.length; i += 1) {
        abnormalTransaction[i].partner = this.getPartnerId(
          abnormalTransaction[i].senderID,
          abnormalTransaction[i].recipientId
        );
      }

      this.transactionList = abnormalTransaction;
    },
    updatePartnerChart(partnerTransaction) {
      const prnrLen = partnerTransaction.length;
      const partnerDataset1 = {
        label: 'Success',
        backgroundColor: this.successColor,
        // data: [611, 517, 467, 392, 221, 189, 169, 161, 155, 130],
        data: [],
        borderAlign: 'inner',
        borderWidth: 0,
        minBarLength: 0,
      };
      const partnerDataset2 = {
        label: 'Error',
        backgroundColor: this.errorColor,
        // data: [11, 17, 67, 92, 21, 89, 69, 61, 55, 30],
        data: [],
        borderAlign: 'inner',
        borderWidth: 0,
        minBarLength: 0,
      };

      this.partnerChartData.labels = [];

      for (let i = 0; i < prnrLen; i += 1) {
        // 2021.5.6 203728 issue 56 Change show company when ownr login
        // 2021.5.27 203728 SPKA-124 Change show company when sp_flag = 'Y'
        // if(this.$cookies.get('comp-id') === this.$cookies.get('ownr-id'))
        // if($cookies.get('user-admin-yn') === 'Y')
        //   this.partnerChartData.labels.push(this.getCompanyId(partnerTransaction[i].userId));
        // else
        //   // this.partnerChartData.labels.push(this.getPartnerId(partnerTransaction[i].senderId, partnerTransaction[i].recipientId));
        //   // 2021.7.15 203728 SPKA-152 get name follow EDI
        //   this.partnerChartData.labels.push(this.getPartnerNameBySrId(partnerTransaction[i]));

        // 2021.7.16 203728 SPKA-152 Change label
        this.partnerChartData.labels.push(this.getLabelTop10(partnerTransaction[i]));
        partnerDataset1.data.push(Number(partnerTransaction[i].success));
        partnerDataset2.data.push(Number(partnerTransaction[i].error));
      }
      this.partnerChartData.datasets = [];
      this.partnerChartData.datasets.push(partnerDataset1);
      this.partnerChartData.datasets.push(partnerDataset2);
      this.$refs.partner_chart.update();
    },
    updateMessageChart(messageTransaction) {
      this.messageOptions.scales.yAxes[0].gridLines.color = this.lineColor;
      this.messageOptions.scales.yAxes[0].gridLines.zeroLineColor = this.lineColor;
      this.messageOptions.scales.yAxes[0].ticks.display = true;
      this.messageOptions.scales.yAxes[0].ticks.fontColor = this.lineColor;
      this.messageOptions.scales.xAxes[0].gridLines.color = this.lineColor;
      this.messageOptions.scales.xAxes[0].gridLines.zeroLineColor = this.lineColor;
      this.messageOptions.scales.xAxes[0].ticks.display = true;
      this.messageOptions.scales.xAxes[0].ticks.fontColor = this.lineColor;
      const messageDatasetSuccess = {
        label: 'Success',
        backgroundColor: this.successColor,
        data: [],
        borderAlign: 'inner',
        borderWidth: 0,
        minBarLength: 0,
      };
      const messageDatasetError = {
        label: 'Error',
        backgroundColor: this.errorColor,
        data: [],
        borderAlign: 'inner',
        borderWidth: 0,
        minBarLength: 0,
      };

      this.messageChartData.labels = [];

      for (let i = 0; i < messageTransaction.length; i += 1) {
        const tmp = messageTransaction[i];
        this.messageChartData.labels.push(tmp.message);
        messageDatasetSuccess.data.push(tmp.success);
        messageDatasetError.data.push(tmp.error);
      }

      this.messageChartData.datasets = [];
      this.messageChartData.datasets.push(messageDatasetSuccess);
      this.messageChartData.datasets.push(messageDatasetError);
      this.$refs.message_chart.update();
    },
    getThStyle() {
      return `color: ${
        this.$vuetify.theme.dark ? '#FFFFFF !important' : '#000000 !important'
      }; background-color: ${
        this.$vuetify.theme.dark ? '#292C35' : '#FFFFFF'
      }; border-left: 0 !important; border-right: 0 !important; font-weight: 600; font-size: 12px;`;
    },
    getTdStyle() {
      return `color: ${
        this.$vuetify.theme.dark ? '#FFFFFF !important' : '#000000 !important'
      };background-color: ${
        this.$vuetify.theme.dark ? '#292C35' : '#FFFFFF'
      }; border-left: 0 !important; border-right: 0 !important; font-weight: 400; font-size: 14px;`;
    },
    getStatusColor(val) {
      return `color: ${
        val === 'error' ? this.errorColor : this.processingColor
      }; font-weight: 700;`;
    },
    getDate(transactionDate) {
      const date = new Date();
      date.setTime(transactionDate);

      return `${date.getFullYear()}-${this.fullZero(date.getMonth() + 1, 2)}-${this.fullZero(
        date.getDate(),
        2
      )} ${this.fullZero(date.getHours(), 2)}:${this.fullZero(date.getMinutes(), 2)}`;
    },
    getChartColor() {
      if (this.themeDark) {
        this.successColor = '#61B0FF';
        this.processingColor = '#30F2BD';
        this.errorColor = '#FF7B7A';
        this.lineColor = '#535761';
      } else {
        this.successColor = '#497DDE';
        this.processingColor = '#5BC5F1';
        this.errorColor = '#FF7B7A';
        this.lineColor = '#C5D1E3';
      }
    },
    fullZero(data, length) {
      let result = `${data}`;
      if (result.length < length) {
        for (let i = result.length; i < length; i += 1) {
          result = `0${result}`;
        }
      }
      return result;
    },
    // getCompanyId(id){
    //   let name = this.compList[id];
    //   return name ? (name.length > 15 ? name.substr(0, 12) + '...' : name) : '';
    // },
    getPartnerId(sender, receiver) {
      // alert(`sender: ${sender}\nreceiver: ${receiver}\nthis.procList: ${JSON.stringify(this.procList)}`);
      let result = '';
      for (let i = 0; i < this.procList.length; i += 1) {
        const proc = this.procList[i];
        if (proc.sendId === sender && proc.recvId === receiver) {
          result = this.prnrList[proc.prnrId];
          // alert(`result: ${result}`);
          break;
        }
      }
      return result;
    },
    // 2021.7.16 203728 SPKA-152 get name follow inbound / outbound
    // getPartnerNameBySrId(obj) {
    //   let name = obj.direction !== "O" ? this.prnrList[obj.senderId] : this.prnrList[obj.recipientId];
    //   return name ? (name.length > 15 ? name.substr(0, 12) + '...' : name) : '';
    // },
    // 2021.7.16 203728 SPKA-152 get name follow inbound / outbound
    getLabelTop10(obj) {
      let label = obj.userId
        ? this.compList[obj.userId]
        : obj.direction !== 'O'
        ? this.prnrList[obj.senderId]
        : this.prnrList[obj.recipientId];
      return label ? (label.length > 15 ? label.substr(0, 12) + '...' : label) : '';
    },

    openMonitoringStateViewWindow(dataItem) {
      const type = 'StateView';
      let item = {
        record: {
          messageInfo: {
            senderId: dataItem.senderId,
            recipientId: dataItem.recipientId,
            messageName: dataItem.message,
          },
          messageSequence: dataItem.messageSequence,
        },
        processId: dataItem.processId,
        partnerName: dataItem.partner,
        direction: '',
        transactionCode: dataItem.status == 'error' ? 'FAIL' : '',
        groupId: this.$cookies.get('comp-id'),
        userId: this.$cookies.get('user-id'),
      };

      const params = {
        ROWID: item.processId.toString(),
        type: type,
        options: {
          dataValue: item,
          id: item.processId.toString(),
        },
      };
      item.id = item.processId;
      const arrView = {
        item,
        type,
      };
      const url = `/monitoring/monitoringStateView/${type}/${params.ROWID}`;
      const size = 'width=1100,height=705,left=120,top=50';
      openWindow({
        arrView,
        url: url,
        params,
        size: size,
        onMessage: (message) => {
          if (message.includes('open-state-file')) {
            this.openDataInformationFileViewWindow(
              JSON.parse(message.replace('open-state-file', ''))
            );
          }
        },
      });
    },

    openDataInformationFileViewWindow(item) {
      const type = 'FileView';

      const params = {
        ROWID: item.recordId.toString(),
        type: type,
        options: {
          dataValue: item,
          id: item.recordId.toString(),
        },
      };
      item.id = item.recordId;
      const arrView = {
        item,
        type,
      };
      const url = `/monitoring/monitoringDataInfoFileView/${type}/${params.ROWID}`;
      const size = 'width=1100,height=721,left=250,top=50';
      openWindow({
        arrView,
        url: url,
        params,
        size: size,
      });
    },
  },
};
</script>

<style>
.theme--light.abnormal-transactions.v-data-table--fixed-header
  tbody
  tr
  td:not(.v-data-table__mobile-row) {
  border: none !important;
}
.theme--light.abnormal-transactions.v-data-table {
  border-top: thin solid #c9ced5;
  border-bottom: none;
  border-right: none;
  border-left: none;
}
.dashboard-period button {
  margin-left: 0 !important;
  border-radius: 5px;
}
/* .v-btn-group button:last-child {
  border-radius: 0 4px 4px 0;
} */
.v-btn__period {
  box-shadow: none !important;
}
.v-btn__active span.v-btn__content {
  font-weight: bold;
}
</style>
